import React from 'react';

export const RequestPropertyImage = () => {
    return (
        <svg
            width="372"
            height="140"
            viewBox="0 0 372 140"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M178.195 38.332C181.344 36.4524 185.269 36.4468 188.423 38.3174L237.708 67.5488C239.664 68.709 239.669 71.5392 237.716 72.7051L188.805 101.904C185.656 103.784 181.731 103.79 178.577 101.919L129.292 72.6875C127.336 71.5273 127.331 68.6972 129.284 67.5312L178.195 38.332Z"
                fill="#DEE6FD"
                stroke="#BED2FF"
                strokeWidth="2"
            />
            <path
                d="M206.013 40.9563L183.267 27.918L160.733 40.9198L160.666 40.8813L160.626 56.0306L160.584 70.6815L183.33 83.7199L205.928 70.6812L206.013 40.9563Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M183.516 27.4844L206.262 40.5225L206.514 40.667L206.513 40.958L206.428 70.6826L206.427 70.9707L206.178 71.1143L183.58 84.1533L183.331 84.2969L183.082 84.1533L160.336 71.1152L160.084 70.9707V70.6797L160.125 56.3174L148.748 49.6963L148.082 49.3086L148.708 48.8584L160.374 40.4756L160.395 40.46L160.417 40.4473L183.019 27.4844L183.267 27.3418L183.516 27.4844Z"
                stroke="#333333"
                strokeMiterlimit="10"
            />
            <path
                d="M206.012 40.9612L183.415 53.9999L160.669 40.9615L183.267 27.9229L206.012 40.9612Z"
                fill="white"
            />
            <path
                d="M183.415 54.0025L160.669 40.9641L160.584 70.689L183.33 83.7274L205.928 70.6888L206.013 40.9639L183.415 54.0025Z"
                fill="#DEE6FD"
            />
            <path
                d="M178.076 62.7508L178.025 80.655L164.325 72.8016L164.376 54.8975L178.076 62.7508Z"
                fill="white"
            />
            <path d="M171.2 76.7687V58.8076" stroke="#DEE6FD" strokeMiterlimit="10" />
            <path
                d="M160.666 40.8809L183.43 53.93L171.766 62.4156L149.001 49.3664L160.666 40.8809Z"
                fill="#FFBE5E"
            />
            <mask
                id="mask0_4436_112269"
                maskUnits="userSpaceOnUse"
                x="149"
                y="40"
                width="35"
                height="23"
            >
                <path
                    d="M160.665 40.876L183.429 53.9252L171.764 62.4107L149 49.3616L160.665 40.876Z"
                    fill="#FFBE5E"
                />
            </mask>
            <g mask="url(#mask0_4436_112269)">
                <path d="M166.174 41.6992L150.526 53.4355" stroke="white" strokeWidth="2" />
                <path d="M170.087 44.8262L156.786 55.7801" stroke="white" strokeWidth="2" />
                <path d="M175.563 47.1768L162.262 58.1307" stroke="white" strokeWidth="2" />
                <path d="M179.475 51.0889L166.174 62.0428" stroke="white" strokeWidth="2" />
            </g>
        </svg>
    );
};
